export enum PaymentProcessingUserActions {
  retry = 'retry',
  drawSignatureDone = 'drawSignatureDone',
  close = 'close',
  check = 'check'
}
